export { ProgressComponent } from './progress.component';
export { L_ProgressModule } from './progress.module';



// WEBPACK FOOTER //
// ./.tmp/progress/index.ts